import LivedigitalSDKError from './LivedigitalSDKError';

class InvalidPayloadError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE: string = 'Invalid payload';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? InvalidPayloadError.DEFAULT_MESSAGE, errorCode ?? 'invalid_payload', meta);
  }
}

export default InvalidPayloadError;
